export { default as identity } from './identity'



// WEBPACK FOOTER //
// ./src/themes/ideal/brand/index.js